module.exports = __webpack_public_path__ + "img/icon-apartment.783d105c.svg";